module.exports = __webpack_public_path__ + "static/media/ball (1).5a49aa48.svg";